export default __webpack_public_path__ + "static/media/dimi-founder.97b260da.webp";